var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.397 3.5L14.0175 11.18C14.2922 11.4246 14.6472 11.5597 15.015 11.5597C15.3828 11.5597 15.7378 11.4246 16.0125 11.18L24.6345 3.5H5.397ZM27 5.4095L18.009 13.421C17.1847 14.1556 16.1191 14.5615 15.015 14.5615C13.9109 14.5615 12.8453 14.1556 12.021 13.421L3 5.381V18.5H27V5.4095ZM3 0.5H27C27.7956 0.5 28.5587 0.816071 29.1213 1.37868C29.6839 1.94129 30 2.70435 30 3.5V18.5C30 19.2956 29.6839 20.0587 29.1213 20.6213C28.5587 21.1839 27.7956 21.5 27 21.5H3C2.20435 21.5 1.44129 21.1839 0.87868 20.6213C0.316071 20.0587 0 19.2956 0 18.5V3.5C0 2.70435 0.316071 1.94129 0.87868 1.37868C1.44129 0.816071 2.20435 0.5 3 0.5V0.5Z",
    fill: "#6B7AE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.740d8b1c4c5bc1f87a0c85fa18c59d71.svg";
export { ForwardRef as ReactComponent };